export const villaPlans = {
    villa1: [
        "https://husamhelper.ru/storage/images/phpna1v32qmvlnf8P8EnZS_resized_600.png",
        "https://husamhelper.ru/storage/images/php8l5c8mgfad0ccD7bR9p_resized_600.png",
        "https://husamhelper.ru/storage/images/phpcr949tkgrod78F1s4K8_resized_600.png"
    ],
    villa2: [
        "https://husamhelper.ru/storage/images/phpbma84m62s0d9bKwDJmS_resized_600.png",
        "https://husamhelper.ru/storage/images/php3mhfbl4crv7j3k9A18y_resized_600.png",
        "https://husamhelper.ru/storage/images/php0fmtm27at2rveI9t7Of_resized_600.png"
    ],
    villa3: [
        "https://husamhelper.ru/storage/images/php80mlhk24jcdo0ynmTCx_resized_600.png",
        "https://husamhelper.ru/storage/images/phpfi4lde3ttlibemYVLKl_resized_600.png",
        "https://husamhelper.ru/storage/images/phpl466g4qkdqeaaaywnD3_resized_600.png"
    ],
    villa4: [
        "https://husamhelper.ru/storage/images/phpd0lmb89kkpt88Sa5h1i_resized_600.png",
        "https://husamhelper.ru/storage/images/phpv0t7754omf858RERJHF_resized_600.png",
        "https://husamhelper.ru/storage/images/phprot1ukoepfl43GqGUKC_resized_600.png"
    ],
    villa5: [
        "https://husamhelper.ru/storage/images/phpj8ruuogscr0l6TYiVBR_resized_600.png",
        "https://husamhelper.ru/storage/images/phpl36smkgges689jaJ7QL_resized_600.png",
        "https://husamhelper.ru/storage/images/phpp7bmavcct5q01DYTIWe_resized_600.png"
    ],
};


export const villaImages = {
    villa1: [
        "https://husamhelper.ru/storage/images/phphq4uvgb3b7mb1uzoFsN_resized_600.jpg",
        "https://husamhelper.ru/storage/images/php3r6srf9l668qac2HVj1_resized_600.jpg",
        "https://husamhelper.ru/storage/images/php731jejmjpmpudpa6jTD_resized_600.jpg",
        "https://husamhelper.ru/storage/images/phpg42up9aekokf1pCasK8_resized_600.jpg",
        "https://husamhelper.ru/storage/images/phpqb43pkdpjmi73YUXCto_resized_600.jpg",
        "https://husamhelper.ru/storage/images/phpmhvr561a7ddn8RopR47_resized_600.jpg",
        "https://husamhelper.ru/storage/images/phpb08h9ovo4stqcm9DblS_resized_600.jpg",
        "https://husamhelper.ru/storage/images/php8irsa9apbce63iecwEl_resized_600.jpg",
        "https://husamhelper.ru/storage/images/phpnqam9pmgrnrr0zRaNub_resized_600.jpg",
        "https://husamhelper.ru/storage/images/phpp4mc8va1aep2aLwPYHE_resized_600.jpg",
        "https://husamhelper.ru/storage/images/php7ngkd91t17n76POGfVr_resized_600.jpg",
        "https://husamhelper.ru/storage/images/php66r4e86dueot8j0WhC6_resized_600.jpg",
        "https://husamhelper.ru/storage/images/php6ue4mqtdg79i7vtaDVJ_resized_600.jpg",
        "https://husamhelper.ru/storage/images/php3h0f7n1gi97e6mbuybG_resized_600.jpg"
    ],
    villa2: [
        "https://husamhelper.ru/storage/images/phprucpv1bmhe5t1V0zmSI_resized_600.jpg",
        "https://husamhelper.ru/storage/images/phpvbs91khm8lf57wnEPzX_resized_600.jpg",
        "https://husamhelper.ru/storage/images/phpkgbistjluprk2zR3B9y_resized_600.jpg",
        "https://husamhelper.ru/storage/images/php83d9pk39gpqmaQcKP2h_resized_600.jpg",
        "https://husamhelper.ru/storage/images/phptedjrks1ho862Adi7e2_resized_600.jpg",
        "https://husamhelper.ru/storage/images/php8b20nr69rqn71gIkzWt_resized_600.jpg",
        "https://husamhelper.ru/storage/images/phpv8gi5uij7n2n2BEWjuL_resized_600.jpg",
        "https://husamhelper.ru/storage/images/phpdpf7mgrr5jbfe5bIzdx_resized_600.jpg",
        "https://husamhelper.ru/storage/images/php8d0op1mjajf9dJGvudo_resized_600.jpg",
        "https://husamhelper.ru/storage/images/phpqqh6605es4jhbBDaKWL_resized_600.jpg",
        "https://husamhelper.ru/storage/images/phpubcsfoou7ik432Cwr0L_resized_600.jpg",
        "https://husamhelper.ru/storage/images/phpa53aloml5cgkakChZha_resized_600.jpg",
        "https://husamhelper.ru/storage/images/php88ooeh5klkko4YJGJN0_resized_600.jpg",
        "https://husamhelper.ru/storage/images/php880lt8pge4mccQNac5K_resized_600.jpg"
    ],
    villa3: [
        "https://husamhelper.ru/storage/images/phpglhr18ca5g0f7rZuW03_resized_600.jpg",
        "https://husamhelper.ru/storage/images/phpcqef27ldfrg586OCLkD_resized_600.jpg",
        "https://husamhelper.ru/storage/images/php02mfjfs4var5fB5bi0J_resized_600.jpg",
        "https://husamhelper.ru/storage/images/phpo6unapm1521e9q1CSLB_resized_600.jpg",
        "https://husamhelper.ru/storage/images/phpsnic5jo40bk41uw42De_resized_600.jpg",
        "https://husamhelper.ru/storage/images/php2qrkrfr7jqfq2ACEgQm_resized_600.jpg",
        "https://husamhelper.ru/storage/images/phpidvgjishpj0q5xe7J35_resized_600.jpg",
        "https://husamhelper.ru/storage/images/php5mlpp9vf753j3NgWuCD_resized_600.jpg",
        "https://husamhelper.ru/storage/images/phpr8sm18piurth0Q1ZKAg_resized_600.jpg",
        "https://husamhelper.ru/storage/images/phpfg4m0ppq0lga9GU97PD_resized_600.jpg",
        "https://husamhelper.ru/storage/images/phpqt276p8hsita58FFjCU_resized_600.jpg",
        "https://husamhelper.ru/storage/images/phpdghrda6sn82f7j8w8wz_resized_600.jpg",
        "https://husamhelper.ru/storage/images/phpstc4o7ebvpk1awmN5my_resized_600.jpg",
        "https://husamhelper.ru/storage/images/php1gb8ipj0bgt92itF1bY_resized_600.jpg"
    ],
    villa4: [
        "https://husamhelper.ru/storage/images/phpqdl9clhp8894fgtcgNk_resized_600.jpg",
        "https://husamhelper.ru/storage/images/phpp587g3bjvf3adANJKAk_resized_600.jpg",
        "https://husamhelper.ru/storage/images/phprkto1ffjadh7cLZWuPY_resized_600.jpg",
        "https://husamhelper.ru/storage/images/phplr0gg6g9at6k7jPGBWv_resized_600.jpg",
        "https://husamhelper.ru/storage/images/phpc7e83f4u3n9b3c9NfiX_resized_600.jpg",
        "https://husamhelper.ru/storage/images/php87pfiu8didddckCEaml_resized_600.jpg",
        "https://husamhelper.ru/storage/images/phph5gngjasi3lcfT3KkBI_resized_600.jpg",
        "https://husamhelper.ru/storage/images/phpqtu16ocrof45ciC4rXB_resized_600.jpg",
        "https://husamhelper.ru/storage/images/phpn3k8mpejefdl8jku8jx_resized_600.jpg",
        "https://husamhelper.ru/storage/images/phppm51hq99dei8aFah8am_resized_600.jpg",
        "https://husamhelper.ru/storage/images/phpql2uhsucbjhndNZ0UhH_resized_600.jpg",
        "https://husamhelper.ru/storage/images/phpku5ejqqtbq42b3wnEoK_resized_600.jpg",
        "https://husamhelper.ru/storage/images/phpsl1bsoh0f99j0yURzYw_resized_600.jpg",
        "https://husamhelper.ru/storage/images/php3rvmtql53l6kdT2weyh_resized_600.jpg"
    ],
    villa5: [
        "https://husamhelper.ru/storage/images/phpn4q36s8fh9424IB4XGt_resized_600.jpg",
        "https://husamhelper.ru/storage/images/php37ucasnh1nhm1blfBIp_resized_600.jpg",
        "https://husamhelper.ru/storage/images/phpvithfoq22ellen7EWj9_resized_600.jpg",
        "https://husamhelper.ru/storage/images/phpe76hsdogltfcfkPnAPI_resized_600.jpg",
        "https://husamhelper.ru/storage/images/phpq5b1jtd9ubu02hBc1DM_resized_600.jpg",
        "https://husamhelper.ru/storage/images/php1ip2gmfle0t07aiVzY3_resized_600.jpg",
        "https://husamhelper.ru/storage/images/phpn3heirlnlmfj0vilOhW_resized_600.jpg",
        "https://husamhelper.ru/storage/images/phpi0ao33llffpr1leoOsM_resized_600.jpg",
        "https://husamhelper.ru/storage/images/phplbrvebeneauv01wqzjT_resized_600.jpg",
        "https://husamhelper.ru/storage/images/phpshd7ao5hmipadS81gxO_resized_600.jpg",
        "https://husamhelper.ru/storage/images/phpdtfekl623080akJKUdb_resized_600.jpg",
        "https://husamhelper.ru/storage/images/phpeop7thdubbks2a7Xc0O_resized_600.jpg",
        "https://husamhelper.ru/storage/images/phph8msrssvvnd12qAS8m8_resized_600.jpg",
        "https://husamhelper.ru/storage/images/phpr2eub76rgs14dMb7TAL_resized_600.jpg"
    ],
};
